import React from "react";
import "./StatusBadge.scss";

const StatusBadgeClientInvite = ({ status }) => {
  const statusColors = {
    Completed: "badge badge-primary",
    Pending: "badge badge-warning",
    Blocked: "badge badge-danger",
  };

  const className = statusColors[status] || "badge badge-secondary";
  return <span className={className}>{status}</span>;
};

export default StatusBadgeClientInvite;
